import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import { getCookie } from "@/utils/cookie";
import { store } from '@/store';
import { moduleForRoute, useAuthorizationStore } from '@/store/authorization';
import { STUDIO_NAVIGATION_ROUTES, SERVICE_PROCESS_NAVIGATION, SERVICE_EDITOR_ROUTES } from '@/config/studioNavigation';
import { STUDIO_DISPLAY_SECTIONS } from '@/config/studioDisplay';

export const Layout = () => import('@/layout/index.vue');

// 静态路由
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: '/authorization-required',
    name: 'AuthorizationRequired',
    meta: { title: '影楼授权' },
    component: () => import('@/view/authorization_required/index.vue')
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/',
        name: 'Home',
        meta: {
          title: '首页'
        },
        component: () => import('@/view/home/index.vue')
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/view/login/index.vue')
      },
      {
        path: '/user_center',
        name: 'UserCenter',
        meta: {
          title: '用户中心'
        },
        component: () => import('@/view/user_center/index.vue')
      },
      {
        path: '/data_status',
        name: 'DataStatus',
        component: () => import('@/view/data_status/index.vue')
      },
      {
        path: '/data_setting',
        name: 'DataSetting',
        component: () => import('@/view/data_setting/index.vue')
      },
      // {
      //   path: '404',
      //   component: () => import('@/views/error_page/404.vue')
      // },
      // {
      //   path: '403',
      //   component: () => import('@/views/error_page/403.vue')
      // }
    ]
  }
];
export const SYSTEM_ROUTES: RouteRecordRaw[] = [
  {
    path: '/System',
    name: 'SystemInit',
    meta: {
      title: '系统设置'
    },
    component: Layout,
    children: [
      {
        path: '/System/DepartmentManage',
        name: 'DepartmentManage',
        meta: {
          title: '部门管理'
        },
        component: () => import('@/view/system_setting/department_manage/index.vue')
      },
      {
        path: '/System/UserManage/',
        name: 'UserManage',
        meta: {
          title: '用户管理'
        },
        component: () => import('@/view/system_setting/user_manage/index.vue')
      },
      {
        path: '/System/JobManage',
        name: 'StudioJob',
        meta: {
          title: '职位管理'
        },
        component: () => import('@/view/system_setting/job_manage/index.vue')
      },
      {
        path: '/System/RoleManage',
        name: 'RoleManage',
        meta: {
          title: '角色管理'
        },
        component: () => import('@/view/system_setting/role_manage/index.vue')
      },
      {
        path: '/System/MenuManage',
        name: 'MenuManage',
        meta: {
          title: '菜单管理'
        },
        component: () => import('@/view/system_setting/menu_manage/index.vue')
      },
      {
        path: '/System/DictManage',
        name: 'DictManage',
        meta: {
          title: '字典管理'
        },
        component: () => import('@/view/system_setting/dictionary_manage/index.vue')
      },
      {
        path: '/System/SysLog',
        name: 'SysLog',
        meta: {
          title: '日志管理'
        },
        component: () => import('@/view/system_setting/log_manage/index.vue')
      }
    ]
  }
];

//数据设置
export const DATA_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Data',
    name: 'DataInit',
    meta: {
      title: '数据设置'
    },
    component: Layout,
    children: [
      {
        path: '/Data/ShootingType',
        name: 'ShootingType',
        meta: {
          title: '拍摄类型'
        },
        component: () => import('@/view/data_setting/shooting_type/index.vue')
      },
      {
        path: '/Data/ShootingLevel',
        name: 'ShootingLevel',
        meta: {
          title: '拍摄级别'
        },
        component: () => import('@/view/data_setting/shooting_level/index.vue')
      },
      {
        path: '/Data/ScenicSpot',
        name: 'ScenicSpot',
        meta: {
          title: '景点管理'
        },
        component: () => import('@/view/data_setting/scenic_spot/index.vue')
      },
      {
        path: '/Data/ProductCategory',
        name: 'ProductCategory',
        meta: {
          title: '产品分类管理'
        },
        component: () => import('@/view/data_setting/product_category/index.vue')
      },
      {
        path: '/Data/Product',
        name: 'Product',
        meta: {
          title: '产品管理'
        },
        component: () => import('@/view/data_setting/product_manage/index.vue')
      },
      {
        path: '/Data/PackageCategory',
        name: 'PackageCategory',
        meta: {
          title: '套系类别管理'
        },
        component: () => import('@/view/data_setting/package_category/index.vue')
      },
      {
        path: '/Data/Package',
        name: 'Package',
        meta: {
          title: '套餐价格'
        },
        component: () => import('@/view/data_setting/package_manage/index.vue')
      },
      {
        path: '/Data/MvCategory',
        name: 'MvCategory',
        meta: {
          title: 'MV类别管理'
        },
        component: () => import('@/view/data_setting/mv_category/index.vue')
      },
      {
        path: '/Data/StudioProcess',
        name: 'StudioProcess',
        meta: {
          title: '流程设置'
        },
        component: () => import('@/view/data_setting/studio_process/index.vue')
      },
      {
        path: '/Data/ConsumptionType',
        name: 'ConsumptionType',
        meta: {
          title: '消费类型'
        },
        component: () => import('@/view/data_setting/consumption_type/index.vue')
      },
      {
        path: '/Data/DocumentCode',
        name: 'DocumentCode',
        meta: {
          title: '单据编码'
        },
        component: () => import('@/view/data_setting/document_code/index.vue')
      },
      { path: '/Customers/Workbench', name: 'CustomerWorkbench', meta: {title:'客资工作台'}, component:()=>import('@/view/customer/crm/Workbench.vue') },
      { path: '/Customers/Insights', name: 'CustomerInsights', meta: {title:'客资分析'}, component:()=>import('@/view/customer/crm/Insights.vue') },
      {
        path: '/Customers/Leads',
        name: 'CustomerLeads',
        meta: { title: '意向客资' },
        component: () => import('@/view/customer/leads/index.vue')
      },
      {
        path: '/Data/StudioMember',
        name: 'StudioMember',
        meta: {
          title: '客户档案'
        },
        component: () => import('@/view/data_setting/studio_member/index.vue')
      },
      {
        path: '/Data/OddIncomeManagement',
        name: 'OddIncomeManagement',
        meta: {
          title: '零散收入项目管理'
        },
        component: () => import('@/view/data_setting/odd_income_management/index.vue')
      }
    ]
  }
]

export const STUDIO_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Studio',
        name: 'Studio',
        meta: {
          title: '影楼列表'
        },
        component: () => import('@/view/studio_setting/studio_manage/index.vue')
      }
    ]
  }
];

export const PURCHASE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Purchase',
        name: 'Purchase',
        meta: {
          title: '订单管理'
        },
        component: () => import('@/view/purchase_setting/purchase_manage/index.vue')
      }
    ]
  }
];

//服务中心
export const SERVICE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Service',
    name: 'Service',
    meta: {
      title: '服务'
    },
    component: Layout,
    children: [
      { path: '/Service/Workbench', name: 'StudioWorkbench', meta: {title:'服务工作台'}, component: () => import('@/view/service_setting/workbench/index.vue') },
      { path: '/Service/OrderCenter', name: 'StudioOrderCenter', meta: {title:'订单中心'}, component: () => import('@/view/service_setting/order_center/index.vue') },
      { path: '/Service/BusinessSetup', name: 'StudioBusinessSetup', meta: {title:'套系与业务设置'}, component: () => import('@/view/service_setting/business_setup/index.vue') },
      {
        path: '/Service/Scheduling',
        name: 'Scheduling',
        meta: {
          title: '排期日历'
        },
        component: () => import('@/view/service_setting/scheduling/index.vue')
      },
      {
        path: '/Service/Order',
        name: 'Order',
        meta: {
          title: '订单管理'
        },
        component: () => import('@/view/service_setting/order/index.vue')
      },
      {
        path: '/Service/Order/OrderDetail/:id',
        name: 'OrderDetail',
        meta: {
          title: '订单详情'
        },
        component: () => import('@/view/service_setting/order_detail/index.vue')
      },
      {
        path: '/Service/OrderRecycle',
        name: 'OrderRecycle',
        meta: {
          title: '订单回收站'
        },
        component: () => import('@/view/service_setting/order_recycle/index.vue')
      },
      { path: '/Service/CustomerJourney', name: 'CustomerJourney', meta: { title: '客户全流程' }, component: () => import('@/view/service_setting/customer_journey/index.vue') },
      // 取件统一查看订单中心；设计、看板和制作进入在线编辑，旧链接保留订单上下文。
      ...SERVICE_PROCESS_NAVIGATION.map((item): RouteRecordRaw => item.processType === 9 ? {
        path: `/Service/${item.name}`,
        name: item.name,
        redirect: to => ({ name: 'StudioOrderCenter', query: to.query, hash: to.hash }),
      } : SERVICE_EDITOR_ROUTES[item.name] ? {
        path: `/Service/${item.name}`,
        name: item.name,
        redirect: to => ({ name: SERVICE_EDITOR_ROUTES[item.name], query: to.query, hash: to.hash }),
      } : ({
        path: `/Service/${item.name}`,
        name: item.name,
        meta: { title: item.title, disabledReason: item.disabledReason },
        props: item.disabledReason ? { title: item.title, reason: item.disabledReason } : { processType: item.processType },
        component: item.disabledReason
          ? () => import('@/view/service_setting/process_work/UnavailableProcess.vue')
          : item.processType === 1 ? () => import('@/view/service_setting/shooting_process/index.vue') : item.processType === 2 ? () => import('@/view/service_setting/makeup_process/index.vue') : item.processType === 10 ? () => import('@/view/service_setting/refining_process/index.vue') : item.processType === 11 ? () => import('@/view/service_setting/mv_process/index.vue') : item.processType === 12 ? () => import('@/view/service_setting/photo_dress_process/index.vue') : item.processType === 13 ? () => import('@/view/service_setting/wedding_dress_process/index.vue') : item.processType === 14 ? () => import('@/view/service_setting/wedding_makeup_process/index.vue') : () => import('@/view/service_setting/process_work/index.vue'),
      })),
    ]
  }
];

//设计板块
export const DESIGN_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Design',
    name: 'Design',
    meta: {
      title: '设计'
    },
    component: Layout,
    children: [
      // 订单设计、送制作、全部订单共用设计订单页，按流程步骤只显示对应阶段。
      {
        path: '/Design/OrderDesign',
        name: 'OrderDesign',
        meta: {
          title: '订单设计'
        },
        props: { scope: 'design' },
        component: () => import('@/view/design_setting/order_design/index.vue')
      },
      {
        path: '/Design/Production',
        name: 'DesignProduction',
        meta: { title: '送制作' },
        props: { scope: 'production' },
        component: () => import('@/view/design_setting/order_design/index.vue')
      },
      {
        path: '/Design/Orders',
        name: 'DesignOrders',
        meta: { title: '全部订单' },
        props: { scope: 'all' },
        component: () => import('@/view/design_setting/order_design/index.vue')
      },
      {
        path: '/Design/DesignTemplate',
        name: 'DesignTemplate',
        meta: {
          title: '设计模板'
        },
        component: () => import('@/view/design_setting/design_template/index.vue')
      },
    ]
  },
  {
    path: '/Design/DesignTemplate/Detail/:id',
    name: 'DesignTemplateDetail',
    meta: {
      title: '设计模板详情'
    },
    component: () => import('@/view/design_setting/design_template/detail.vue')
  },
  {
    path: '/Design/OrderDesign/Detail/:id/:orderNo',
    name: 'OrderDesignDetail',
    meta: {
      title: '订单设计详情'
    },
    component: () => import('@/view/design_setting/order_design/detail.vue')
  },
];
//财务板块
export const FINANCE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Finance',
    name: 'Finance',
    meta: {
      title: '财务'
    },
    component: Layout,
    children: [
      {
        path: '/Finance/PaymentRecords',
        name: 'PaymentRecords',
        meta: {
          title: '收款记录'
        },
        component: () => import('@/view/finance/payment_records/index.vue')
      },
      {
        path: '/Finance/DailyReport',
        name: 'DailyReport',
        meta: {
          title: '日报表'
        },
        component: () => import('@/view/finance/daily_report/index.vue')
      },
      {
        path: '/Finance/MonthlyReport',
        name: 'MonthlyReport',
        meta: {
          title: '月报表'
        },
        component: () => import('@/view/finance/monthly_report/index.vue')
      },
      {
        path: '/Finance/AnnualReport',
        name: 'AnnualReport',
        meta: {
          title: '年报表'
        },
        component: () => import('@/view/finance/annual_report/index.vue')
      },
      {
        path: '/Finance/AnnualSurplusAnalysis',
        name: 'AnnualSurplusAnalysis',
        meta: {
          title: '年余款分析'
        },
        component: () => import('@/view/finance/annual_surplus_analysis/index.vue')
      },
      {
        path: '/Finance/MonthlyProcessReport',
        name: 'MonthlyProcessReport',
        meta: {
          title: '月流程报表'
        },
        component: () => import('@/view/finance/monthly_process_report/index.vue')
      },
      {
        path: '/Finance/MonthlyUnpaidReport',
        name: 'MonthlyUnpaidReport',
        meta: {
          title: '月未缴报表'
        },
        component: () => import('@/view/finance/monthly_unpaid_report/index.vue')
      },
      {
        path: '/Finance/CustomerConsumptionRecords',
        name: 'CustomerConsumptionRecords',
        meta: {
          title: '客户消费表'
        },
        component: () => import('@/view/finance/customer_consumption_records/index.vue')
      },
      {
        path: '/Finance/RefundAndReturnRecords',
        name: 'RefundAndReturnRecords',
        meta: {
          title: '退单/退款表'
        },
        component: () => import('@/view/finance/refund_and_return_records/index.vue')
      },
    ]
  }
];
//测试用
export const TEST_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Test',
    name: 'Test',
    meta: {
      title: '测试'
    },
    component: Layout,
    children: [
      {
        path: '/Test/Print',
        name: 'Print',
        meta: {
          title: '打印测试'
        },
        component: () => import('@/view/test/Print.vue')
      }
    ]
  }
];

// 在线编辑模块下的设计看样与精修看样，共用看样管理页面。
export const PROOFING_ROUTES: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/Design/Proofing',
        name: 'DesignProofing',
        meta: { title: '设计看样' },
        props: { proofingType: 'design' },
        component: () => import('@/view/proofing/index.vue')
      },
      {
        path: '/Proofing',
        name: 'Proofing',
        meta: {
          title: '精修看样'
        },
        props: { proofingType: 'refine' },
        component: () => import('@/view/proofing/index.vue')
      }
    ]
  }
];

// 门店对外展示页的管理入口与已接入的内容编辑。
export const STUDIO_DISPLAY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Display',
    component: Layout,
    children: [
      {
        path: '', name: 'StudioDisplayOverview', meta: { title: '展示页概览' },
        component: () => import('@/view/studio_display/index.vue'),
      },
      {
        path: 'ShootingType', name: 'StudioDisplayShootingType', meta: { title: '拍摄类型' },
        component: () => import('@/view/data_setting/shooting_type/index.vue'),
      },
      {
        path: 'Locations', name: 'StudioDisplayLocations', meta: { title: '景点路线' },
        component: () => import('@/view/studio_display/locations/index.vue'),
      },
      ...STUDIO_DISPLAY_SECTIONS.map(section => ({
        path: section.key, name: section.name, meta: { title: section.title, disabledReason: section.disabledReason },
        redirect: section.hidden ? { name: 'StudioDisplayOverview' } : undefined,
        props: { sectionKey: section.key, ...(section.key === 'Photos' ? { galleryKind: 'photos' } : {}) },
        component: section.key === 'Brand'
          ? () => import('@/view/studio_display/brand/index.vue')
          : ['Styles', 'Photos'].includes(section.key) ? () => import('@/view/studio_display/gallery/Library.vue')
          : section.key === 'Packages' ? () => import('@/view/data_setting/package_manage/index.vue')
          : section.key === 'Products' ? () => import('@/view/studio_display/products/index.vue')
          : () => import('@/view/studio_display/index.vue'),
      })),
      {
        path: 'Styles/Category/:categoryId', name: 'StudioDisplayStyleCategory', meta: { title: '案例相册' },
        props: true, component: () => import('@/view/studio_display/gallery/Library.vue'),
      },
      {
        path: 'Styles/Album/:albumId', name: 'StudioDisplayStyleAlbum', meta: { title: '图片详情管理' },
        props: true, component: () => import('@/view/studio_display/gallery/Album.vue'),
      },
      {
        path: 'Photos/Category/:categoryId', name: 'StudioDisplayPhotoCategory', meta: { title: '客片相册' },
        props: route => ({ categoryId: route.params.categoryId, galleryKind: 'photos' }),
        component: () => import('@/view/studio_display/gallery/Library.vue'),
      },
      {
        path: 'Photos/Album/:albumId', name: 'StudioDisplayPhotoAlbum', meta: { title: '客片图片详情管理' },
        props: route => ({ albumId: route.params.albumId, galleryKind: 'photos' }),
        component: () => import('@/view/studio_display/gallery/Album.vue'),
      },
    ],
  },
];

// 工厂选品商城（影楼内部采购，不套后台 Layout）
export const SHOWCASE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Product/Showcase',
    name: 'ProductShowcase',
    meta: {
      title: '选品商城'
    },
    component: () => import('@/view/product/product_showcase/index.vue')
  }
];

// 消息中心（影楼端 PC 管理页，Layout 子路由，经顶栏铃铛/「我的消息」进入）
export const MESSAGE_ROUTES: RouteRecordRaw[] = [
  {
    path: '/Message',
    name: 'Message',
    meta: {
      title: '消息'
    },
    component: Layout,
    children: [
      {
        path: '/Message/Center',
        name: 'MessageCenter',
        meta: {
          title: '消息中心'
        },
        component: () => import('@/view/message_center/index.vue')
      }
    ]
  }
];

// 客户手机端看样（公开链接，不套后台 Layout）
export const CUSTOMER_PROOFING_ROUTES: RouteRecordRaw[] = [
  {
    // ⚠️ shareCode 两处都必须必填：可选参数会把裸 /Proofing（PC 管理页）也吃掉，
    // 且 vue-router 要求 alias 与原路径参数可选性一致（否则 dev 告警）
    path: '/proofing/v/:shareCode',
    alias: ['/Proofing/:shareCode'],
    name: 'CustomerProofing',
    meta: {
      title: '客户看样',
      public: true
    },
    component: () => import('@/view/customer_proofing/index.vue')
  }
];

// 公开门店展示页 /s/{code} 由独立入口 showroom.html（src/router/showroom.ts）承载，不在后台路由中。
const INIT_ROUTES = [
  ...constantRoutes,
  ...SYSTEM_ROUTES,
  ...DATA_ROUTES,
  ...STUDIO_ROUTES,
  ...PURCHASE_ROUTES,
  ...SERVICE_ROUTES,
  ...DESIGN_ROUTES,
  ...FINANCE_ROUTES,
  ...TEST_ROUTES,
  ...PROOFING_ROUTES,
  ...STUDIO_DISPLAY_ROUTES,
  ...SHOWCASE_ROUTES,
  ...MESSAGE_ROUTES,
  ...CUSTOMER_PROOFING_ROUTES
];

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(),
  routes: INIT_ROUTES as RouteRecordRaw[],
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 })
});

// 回登录页
export function goLogin() {
  const tenantCode = localStorage.getItem('tenantCode');
  router.push('/login/' + tenantCode);
}

// 开放导航中的业务页及必要的辅助路由，继续独立校验商业授权。
const ALLOWED_ROUTES = new Set<string>([
  ...STUDIO_NAVIGATION_ROUTES,
  'Login',
  'AuthorizationRequired',
  'Home',
  'ProductShowcase',
  'CustomerProofing',
  'Design', 'OrderDesign', 'OrderDesignDetail', 'DesignTemplate', 'DesignTemplateDetail',
  'Proofing', 'DesignProofing',
  'Message', 'MessageCenter',
  'Service', 'Order', 'OrderDetail',
  'SystemInit', 'DepartmentManage', 'StudioJob', 'RoleManage', 'MenuManage', 'UserManage',
  'UserCenter'
]);

// 路由守卫
let navigationRequest = 0;
router.beforeEach(async (to) => {
  const request = ++navigationRequest;
  if (to.meta?.public) return true;
  const authorization = useAuthorizationStore(store);
  const token = getCookie("photo_user_token");
  if (to.name === 'Login') { authorization.reset(); return true; }
  if (!token) { authorization.reset(); return { name: 'Login' }; }
  // This page is the fail-closed destination and must remain reachable when checking fails.
  if (to.name === 'AuthorizationRequired') return true;
  try {
    await authorization.refresh();
  } catch {
    if (request !== navigationRequest || (getCookie('photo_user_token') && getCookie('photo_user_token') !== token)) return false;
    if (!getCookie('photo_user_token')) return { name: 'Login' };
    return { name: 'AuthorizationRequired', query: { redirect: to.fullPath }, replace: true };
  }
  if (request !== navigationRequest || getCookie('photo_user_token') !== token) return false;
  if (!to.name || !ALLOWED_ROUTES.has(to.name as string)) return { name: 'Home', replace: true };
  const module = moduleForRoute(to.name);
  if (module && !authorization.hasModule(module)) {
    return { name: 'AuthorizationRequired', query: { redirect: to.fullPath, module }, replace: true };
  }
  // 兼容旧书签及历史入口，设计看样统一进入独立主导航。
  if (to.name === 'Proofing' && to.query.tab === 'design') {
    const { tab: _tab, ...query } = to.query;
    return { name: 'DesignProofing', query, replace: true };
  }
  return true;
});


export default router;
